<script>

import UsersForm from './UsersForm';

export default {
  props: ['replacefilters', 'changefilters'],
  components: { UsersForm },
  data() {
    return {
      dsbl_btn: false,
      show_filters: false,
      changes: false,

      search: '',
      dateRange: { startDate: null, endDate: null },
      verifieds: [
        {value: 'verified', name: 'Verified'},
        {value: 'not_verified', name: 'Not Verified'},
        {value: 'all', name: 'Verified & Not Verified'},
      ],
      verified_value: 'all',
      referred_bys: [
        {id: 'phone call', name: 'Phone Call', active: false},
        {id: 'text message', name: 'Text Message', active: false},
        {id: 'television ad', name: 'Television Ad', active: false},
        {id: 'radio ad', name: 'Radio Ad', active: false},
        {id: 'internet ad', name: 'Internet Ad', active: false},
        {id: 'facebook', name: 'Facebook', active: false},
        {id: 'instagram', name: 'Instagram', active: false},
        {id: 'event', name: 'Event', active: false},
        {id: 'mail brochure', name: 'Mail - Brochure', active: false},
        {id: 'mail postcard', name: 'Mail - Postcard', active: false},
        {id: 'referral', name: 'Referral from another client', active: false},
        {id: 'repeat client', name: 'Repeat Client', active: false},
      ],
      haslistings: [
        {value: 'has_listings', name: 'Has Listings'},
        {value: 'no_listings', name: 'No Listings'},
        {value: 'all', name: 'Has & No Listings'},
      ],
      haslistings_value: 'all',
      hasroles: [
        {value: 'has_roles', name: 'Has Roles'},
        {value: 'no_roles', name: 'No Roles'},
        {value: 'all', name: 'Has & No Roles'},
      ],
      hasroles_value: 'all',

      default_new_user: {
        name: '',
        email: '',
        website: '',
      },
      new_user: {},

      loading: true,
      results: [],
      pagination: {},
      filters: {
        paginate: 50,
        page: 1,
        total: 0,
        withcounts: ['listings','roles'],
        havings: [],
        nothavings: [],
        wherenulls: [],
        notnulls: [],
        whereins: {
          website: [],
        },
        wherehas: {
          roles: {
            search: ['title'],
          },
        },
        orderbys: {
          name: '',
          email: '',
          phone: '',
          last_active: 'desc',
          created_at: 'desc',
        },
        betweens: {
          created_at: {
            start: '',
            end: ''
          }
        },
        searchs: {
          search1: {
            value: ''
          }
        }
      },
    }
  },
  watch: {
    'dateRange': { handler: function(n, o) {
      if(n.startDate && n.endDate && this.moment(n.startDate).isValid() && this.moment(n.endDate).isValid()) {
        this.filters.betweens.created_at.start = this.moment(n.startDate).startOf('day').format();
        this.filters.betweens.created_at.end = this.moment(n.endDate).endOf('day').format();
      } else {
        this.filters.betweens.created_at.start = '';
        this.filters.betweens.created_at.end = '';
      }
    }, deep: true },
    '$route.params.id': function (id) { if(!id) { console.log("Route param changed. Updating"); this.fetchData(); } },

    'loading': { handler: function(n, o) { this.$emit('loadchange', n) }},

    'filters.paginate': { handler: function(n, o) { this.pagination.current_page = 1; this.fetchData(); }},
  },
  created() {
    if(this.replacefilters) {
      this.filters = this.replacefilters;
    } else if(this.changefilters) {
      for(var i in this.changefilters) {
        this.filters[i] = this.changefilters[i];
      }
    }
    
    // this.filters.whereins.website = [this.website_id];
    this.default_new_user.website = this.website_id;
    this.new_user = JSON.parse(JSON.stringify(this.default_new_user));

    this.setWhereIns('referred_bys','filters','referred_by');

    this.fetchData();
  },
  mounted() {
    window.addEventListener('scroll', this.setStickyNav);
    window.addEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').addEventListener('scroll', this.setStickyNav); }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.setStickyNav);
    window.removeEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').removeEventListener('scroll', this.setStickyNav); }
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.filters.page = this.pagination.current_page;
      this.$http.get('/api/users/fetch', {params: this.filters}).then(res => {
        // console.log(res);
        this.results = res.data.data;
        this.pagination = res.data;
        this.filters.total = res.data.total;
        this.loading = false;
        this.changes = false;
      }).catch(res => { this.loading = false; this.popupErrors(res); });
    },
    add_user() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;

      this.$http.post('/api/users/store', this.new_user).then(res => {
        // console.log(res);
        this.new_user = JSON.parse(JSON.stringify(this.default_new_user));
        this.$refs.modal_add_user.hide();
        this.fetchData();
        this.dsbl_btn = false;
      }).catch(res => { this.dsbl_btn = false; this.popupErrors(res); });
    },
    export_users() {
      if(this.disabled == true) { this.$noty.warning('Disabled'); return; } this.disabled = true; this.loading = true;
      this.$http.get('/api/users/export', {params: this.filters, responseType: 'arraybuffer'}).then(res => {
        // console.log(res);
        var newBlob = new Blob([res.data], {type: res.headers['content-type']});
        if(window.navigator && window.navigator.msSaveOrOpenBlob) { window.navigator.msSaveOrOpenBlob(newBlob); return; }
        const data = window.URL.createObjectURL(newBlob);
        var link = document.createElement('a'); link.href = data; link.download = 'users_export.csv'; link.click();
        setTimeout(function () { window.URL.revokeObjectURL(data) }, 100);
        this.disabled = false; this.loading = false;
      }).catch(res => { this.popupErrors(res); this.disabled = false; this.loading = false; });
    },
    changeVerified() {
      if(this.verified_value == 'verified') {
        this.filters.wherenulls = [];
        this.filters.notnulls = ['email_verified_at'];
      } else if(this.verified_value == 'not_verified') {
        this.filters.wherenulls = ['email_verified_at'];
        this.filters.notnulls = [];
      } else {
        this.filters.wherenulls = [];
        this.filters.notnulls = [];
      }
    },
    changeHasListings() {
      if(this.haslistings_value == 'has_listings') {
        if(!this.filters.havings.includes('listings_count')) { this.filters.havings.push('listings_count'); }
        if(this.filters.nothavings.includes('listings_count')) { this.filters.nothavings.splice('listings_count', 1); }
      } else if(this.haslistings_value == 'no_listings') {
        if(this.filters.havings.includes('listings_count')) { this.filters.havings.splice('listings_count', 1); }
        if(!this.filters.nothavings.includes('listings_count')) { this.filters.nothavings.push('listings_count'); }
      } else {
        if(this.filters.havings.includes('listings_count')) { this.filters.havings.splice('listings_count', 1); }
        if(this.filters.nothavings.includes('listings_count')) { this.filters.nothavings.splice('listings_count', 1); }
      }
    },
    changeHasRoles() {
      if(this.hasroles_value == 'has_roles') {
        if(!this.filters.havings.includes('roles_count')) { this.filters.havings.push('roles_count'); }
        if(this.filters.nothavings.includes('roles_count')) { this.filters.nothavings.splice('roles_count', 1); }
      } else if(this.hasroles_value == 'no_roles') {
        if(this.filters.havings.includes('roles_count')) { this.filters.havings.splice('roles_count', 1); }
        if(!this.filters.nothavings.includes('roles_count')) { this.filters.nothavings.push('roles_count'); }
      } else {
        if(this.filters.havings.includes('roles_count')) { this.filters.havings.splice('roles_count', 1); }
        if(this.filters.nothavings.includes('roles_count')) { this.filters.nothavings.splice('roles_count', 1); }
      }
    },
    setWhereIns(items,filters,wherein) {
      var temp = [], all = true; for(var i in this[items]) { if(this[items][i].active) { temp.push(this[items][i].id); } else { all = false; } }

      var path = filters.split('.');
      var obj = this;
      for(var i in path) { obj = obj[path[i]]; }
      if(all) { obj.whereins[wherein] = ""; } else { obj.whereins[wherein] = temp; }
    },
  }
}
</script>

<template>
  <div>
    
    <transition name="fade">
      <div class="ribbon-two ribbon-two-primary" :key="1" v-if="loading"><span><i class="spinner-border spinner-border-sm"></i></span></div>
    </transition>
    <div class="px-4 pt-4 pb-3">
      <div class="row">
        <div class="col-lg-8">
          <div class="form-inline">
            <button type="button" @click="fetchData()" class="btn btn-light mr-2 mb-2"><Icon icon="ri:refresh-line"></Icon></button>
            <div class="form-group mr-2 mb-2">
              <input type="text" class="form-control" placeholder="Search..." v-model="filters.searchs.search1.value" @change="changes = true">
            </div>
            <w-field class="mr-2 mb-2" SimpleDataType="String List, Multi" :Options="app_website_ids" v-model="filters.whereins.website" placeholder="Websites..." @input="changes = true"></w-field>
            <div class="form-group mr-2 mb-2">
              <button type="button" class="btn btn-primary dropdown-toggle" @click="show_filters ? show_filters = false : show_filters = true">Filters
                <Icon v-if="show_filters" icon="ri:arrow-drop-down-line"></Icon>
                <Icon v-else icon="ri:arrow-drop-right-line"></Icon>
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="text-lg-right mt-3 mt-lg-0">
            <!-- <button type="button" @click="export_users()" class="btn btn-light ml-2" v-tippy content="Export to CSV file. Includes selected filters."><Icon icon="ri:download-cloud-2-line"></Icon></button> -->
            <button type="button" @click="new_user = JSON.parse(JSON.stringify(default_new_user)); $refs.modal_add_user.show()" class="btn btn-success ml-2"><Icon icon="ri:add-line"></Icon> Add New</button>
          </div>
          <b-modal ref="modal_add_user" centered size="xl" title="Create a new user" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-footer="true">
            <b-form @submit.prevent="add_user">
              <div class="p-4">
                <UsersForm :item="new_user"></UsersForm>
              </div>
              <footer class="modal-footer">
                <button type="button" class="btn btn-light" @click="$refs.modal_add_user.hide()" :disabled="dsbl_btn"><Icon icon="ri:close-fill" /> Cancel</button>
                <button type="submit" class="btn btn-primary" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:save-line" /> Save</button>
              </footer>
            </b-form>
          </b-modal>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div v-if="show_filters" class="form-inline px-2 pt-2 bg-gray-200">

        <div class="form-group mr-2 mb-2">
          <w-field SimpleDataType="String List, Single" v-model="verified_value" :Options="verifieds" placeholder="Filter by verified..." @input="changeVerified(); changes = true"></w-field>
        </div>

        <div class="form-group mr-2 mb-2 position-relative">
          <button type="button" class="btn btn-white dropdown-toggle font-weight-500" data-toggle="dropdown">
            Referred by: ({{referred_bys.filter(b=>{return b.active}).length}}/{{referred_bys.length}})
            <Icon icon="ri:arrow-down-s-line" />
          </button>
          <div class="dropdown-menu dropdown-menu-right" onclick="event.stopPropagation()">
            <div v-for="(item, index) in referred_bys" :key="item.id" class="dropdown-item">
              <p-check class="p-default p-curve p-smooth pretty-light w-100" color="success-o" v-model="item.active" @change="setWhereIns('referred_bys','filters','referred_by'); changes = true"> <span class="ml-1">{{item.name}}</span></p-check>
            </div>
          </div>
        </div>

        <div class="form-group mr-2 mb-2">
          <w-field SimpleDataType="String List, Single" v-model="haslistings_value" :Options="haslistings" placeholder="Filter by listings..." @input="changeHasListings(); changes = true"></w-field>
        </div>

        <div class="form-group mr-2 mb-2">
          <w-field SimpleDataType="String List, Single" v-model="hasroles_value" :Options="hasroles" placeholder="Filter by roles..." @input="changeHasRoles(); changes = true"></w-field>
        </div>

        <div class="form-group mr-2 mb-2">
          <w-field SimpleDataType="Date range" v-model="dateRange" placeholder="Filter by date created..." @input="changes = true"></w-field>
        </div>

        <div class="form-group mr-2 mb-2">
          <select class="form-control" v-model="filters.paginate">
            <option value="50">Per page: (50)</option>
            <option value="100">Per page: (100)</option>
            <option value="250">Per page: (250)</option>
            <option value="500">Per page: (500)</option>
            <option value="750">Per page: (750)</option>
            <option value="1000">Per page: (1000)</option>
          </select>
        </div>

      </div>
    </transition>
    <transition name="fade">
      <div v-if="changes" class="alert alert-info rounded-0 m-0">Click <Icon icon="ri:refresh-line" /> commit any changes made to filters.</div>
    </transition>
    <div class="row">
      <div class="col-sm-12">
        <div class="table-responsive m-0">
          <table class="table table-small sticky-header table-bordered-right table-hover mb-0 table-centered text-nowrap">
            <thead>
              <tr>
                <th><tdsort coltext="Name" :orderby.sync="filters.orderbys.name" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Email" :orderby.sync="filters.orderbys.email" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Phone" :orderby.sync="filters.orderbys.phone" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Website" :orderby.sync="filters.orderbys.website" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Verified" :orderby.sync="filters.orderbys.email_verified_at" @do="fetchData()"></tdsort></th>
                <th>Listings</th>
                <th>Roles</th>
                <th><tdsort coltext="Referral type" :orderby.sync="filters.orderbys.referred_by" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Referred by" :orderby.sync="filters.orderbys.referred_name" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Last active" :orderby.sync="filters.orderbys.last_active" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Created on" :orderby.sync="filters.orderbys.created_at" @do="fetchData()"></tdsort></th>
              </tr>
              <tr class="sticky-thead bg-white">
                <th><tdsort coltext="Name" :orderby.sync="filters.orderbys.name" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Email" :orderby.sync="filters.orderbys.email" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Phone" :orderby.sync="filters.orderbys.phone" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Website" :orderby.sync="filters.orderbys.website" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Verified" :orderby.sync="filters.orderbys.email_verified_at" @do="fetchData()"></tdsort></th>
                <th>Listings</th>
                <th>Roles</th>
                <th><tdsort coltext="Referral type" :orderby.sync="filters.orderbys.referred_by" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Referred by" :orderby.sync="filters.orderbys.referred_name" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Last active" :orderby.sync="filters.orderbys.last_active" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Created on" :orderby.sync="filters.orderbys.created_at" @do="fetchData()"></tdsort></th>
              </tr>
            </thead>
            <tbody>
              <router-link v-for="(item, index) in results" :key="item.id" :to="'/contacts/'+item.id" tag="tr" class="_c-pointer" exact>
                <td class="p-1">
                  <div class="d-inline-block align-middle">
                    <img v-if="item.avatar" :src="formatImage(item.avatar)" class="_w-50 rounded">
                    <avatar v-else :username="item.name" :size="50" :rounded="false" class="rounded"></avatar>
                  </div>
                  <div class="ml-1 d-inline-block align-middle">
                    <router-link :to="'/contacts/'+item.id">
                      <div class="text-dark font-weight-bold"><Icon icon="ri:checkbox-blank-circle-fill" height="9" class="mx-1" :class="moment().diff(moment(item.last_active), 'minutes') < 10 ? 'text-success' : 'text-light'" /> {{item.name}}</div>
                    </router-link>
                  </div>
                </td>
                <td>{{item.email}}</td>
                <td>{{formatPhone(item.phone)}}</td>
                <td>{{ item.website }}</td>
                <td class="py-1"><div class="alert m-0" :class="item.email_verified_at ? 'alert-success' : 'alert-danger'">{{item.email_verified_at ? 'Yes' : 'No'}}</div></td>
                <td><span v-if="item.listings_count">{{item.listings_count}}</span></td>
                <td><span v-for="(role, role_i) in item.roles" :key="role.id" class="p-1 d-inline-block small bg-gray-100 border rounded mr-1 mb-1">{{role.title}}</span></td>
                <td>{{ item.referred_by }}</td>
                <td>{{ item.referred_name }}</td>
                <td v-tippy :content="moment(item.last_active).format('lll')">{{moment(item.last_active).fromNow()}}</td>
                <td v-tippy :content="moment(item.created_at).format('lll')">{{moment(item.created_at).fromNow()}}</td>
              </router-link>
            </tbody>
          </table>
          <div class="p-3 border-top border-light">
            <w-pagination :pagination="pagination" @paginate="results=[]; fetchData()" :offset="4"></w-pagination>
          </div>
        </div>
      </div>
    </div>

  </div>



  
</template>
